import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    mapping: Object
  }

  connect () {
    this._applyClasses()
  }

  disconnect () {
    this._removeClasses()
  }

  disconnectManually (event) {
    event.preventDefault()
    this._removeClasses()
  }

  _applyClasses () {
    Object.entries(this.mappingValue).forEach(([selectorAttr, className]) => {
      const targets = document.querySelectorAll(`[${selectorAttr}]`)
      targets.forEach(target => {
        target.classList.add(className)
      })
    })
  }

  _removeClasses () {
    Object.entries(this.mappingValue).forEach(([selectorAttr, className]) => {
      const targets = document.querySelectorAll(`[${selectorAttr}]`)
      targets.forEach(target => {
        target.classList.remove(className)
      })
    })
  }
}
